import { j as D } from "./jsx-runtime-944c88e2.js";
import * as m from "react";
import { E as F, S as R, C as V, a as C, i as v, r as j, u as M, b as G, g as y, c as I, d as E, e as O, f as L, h as S, j as z, k as N, l as $, I as W, m as Y, t as B, D as w, n as K, T as U } from "./TreeView-aa1ef3e3.js";
import { p as X, aX as Z, aY as q, aZ as Q, w as H } from "./index.es-6889c727.js";
import "./index-efd35e77.js";
import "./Reveal-e2f427f6.js";
import "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "react-dom";
import "./index-64063129.js";
import "./auto-scroll-b2de6e53.js";
var _ = globalThis && globalThis.__assign || function() {
  return _ = Object.assign || function(r) {
    for (var t, e = 1, s = arguments.length; e < s; e++) {
      t = arguments[e];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, _.apply(this, arguments);
};
function J(r, t) {
  if (!r || !r.length)
    return [];
  var e = r, s = t.cloneField || "cloned", i = t.expandField || F, n = t.selectField || R, l = t.checkField || V, a = t.childrenField || C;
  return e = b(e, i, t.expand, s, a), e = b(e, n, t.select, s, a), e = b(e, l, t.check, s, a), te(e, a, t.check), e;
}
function b(r, t, e, s, i) {
  if (e) {
    var n = k(e, t), l = n.ids, a = n.field, f = !v(e) && e.idField ? j(l, e.idField, r, i) : l;
    return ee(r, f, a, s, i);
  } else
    return r;
}
function k(r, t) {
  var e, s;
  return v(r) ? (e = r, s = t) : (e = r.ids || [], s = r.operationField || t), { ids: e, field: s };
}
function ee(r, t, e, s, i) {
  var n = r;
  return t.forEach(function(l) {
    n = M(n, l, function(a) {
      return A(e, a);
    }, s, i);
  }), n;
}
function A(r, t) {
  for (var e = (r || "").split("."), s = t, i = 0; i < e.length; i++) {
    var n = e[i];
    if (i === e.length - 1)
      s[n] = !0;
    else if (s[n] !== void 0)
      s[n] = _({}, s[n]), s = s[n];
    else
      return;
  }
}
function te(r, t, e) {
  if (e && !v(e) && e.applyCheckIndeterminate)
    for (var s = k(e, V).field, i = e.checkIndeterminateField || G, n = 0; n < r.length; n++) {
      var l = r[n], a = l[t];
      a && T(a, y(s, l) ? [] : [l], t, s, i);
    }
}
function T(r, t, e, s, i) {
  for (var n = !1, l = 0; l < r.length; l++) {
    var a = r[l];
    if (y(s, a)) {
      if (!n)
        for (var f = 0; f < t.length; f++)
          A(i, t[f]);
      n = !0, a[e] && T(a[e], [], e, s, i);
    } else
      a[e] && T(a[e], n ? [a] : t.concat([a]), e, s, i);
  }
}
function re(r, t, e, s, i, n) {
  var l = n || C;
  if (!p())
    return u();
  var a = I(r, t, l);
  if (!a)
    return u();
  if (!i || i === t) {
    if (!h())
      return u();
    var f = E(r, l, t), o = O(a, e, l, L(r, s), f);
    return i ? { sourceData: o, targetData: o } : o;
  } else {
    var d = E(r, l, t), c = O(a, e, l, s, i);
    return { sourceData: d, targetData: c };
  }
  function u() {
    return i ? { sourceData: t, targetData: i } : t;
  }
  function h() {
    return !"".concat(s, "_").startsWith("".concat(r, "_"));
  }
  function p() {
    if (!t || !t.length || !r || !s || i && !i.length)
      return !1;
    var P = !i || i === t ? t : i;
    return !!I(s, P, l);
  }
}
var ne = globalThis && globalThis.__generator || function(r, t) {
  var e = { label: 0, sent: function() {
    if (n[0] & 1)
      throw n[1];
    return n[1];
  }, trys: [], ops: [] }, s, i, n, l;
  return l = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function a(o) {
    return function(d) {
      return f([o, d]);
    };
  }
  function f(o) {
    if (s)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (s = 1, i && (n = o[0] & 2 ? i.return : o[0] ? i.throw || ((n = i.return) && n.call(i), 0) : i.next) && !(n = n.call(i, o[1])).done)
          return n;
        switch (i = 0, n && (o = [o[0] & 2, n.value]), o[0]) {
          case 0:
          case 1:
            n = o;
            break;
          case 4:
            return e.label++, { value: o[1], done: !1 };
          case 5:
            e.label++, i = o[1], o = [0];
            continue;
          case 7:
            o = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (n = e.trys, !(n = n.length > 0 && n[n.length - 1]) && (o[0] === 6 || o[0] === 2)) {
              e = 0;
              continue;
            }
            if (o[0] === 3 && (!n || o[1] > n[0] && o[1] < n[3])) {
              e.label = o[1];
              break;
            }
            if (o[0] === 6 && e.label < n[1]) {
              e.label = n[1], n = o;
              break;
            }
            if (n && e.label < n[2]) {
              e.label = n[2], e.ops.push(o);
              break;
            }
            n[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        o = t.call(r, e);
      } catch (d) {
        o = [6, d], i = 0;
      } finally {
        s = n = 0;
      }
    if (o[0] & 5)
      throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
};
function ie(r, t, e, s, i) {
  if (s === void 0 && (s = {}), !e || !e.length)
    return [];
  var n = se(t), l = n.ids, a = n.idField, f = a ? y(a, r.item) : r.itemHierarchicalIndex, o = l.indexOf(f), d = o === -1, c = i || C, u;
  return s.singleMode ? u = d ? [f] : [] : (u = l.slice(), d ? u.push(f) : u.splice(o, 1), s.checkChildren && ae(r.item, r.itemHierarchicalIndex, d, a, c, u), s.checkParents && le(r.itemHierarchicalIndex, d, a, c, u, e)), v(t) ? u : Object.assign({}, t, { ids: u });
}
function se(r) {
  var t, e = void 0;
  return v(r) ? t = r : (t = r.ids || [], e = r.idField), { ids: t, idField: e };
}
function ae(r, t, e, s, i, n) {
  S(r, t, i, s).forEach(function(l) {
    e && n.indexOf(l) === -1 ? n.push(l) : !e && n.indexOf(l) > -1 && n.splice(n.indexOf(l), 1);
  });
}
function le(r, t, e, s, i, n) {
  var l = d(), a = l.next();
  t ? f() : o();
  function f() {
    for (; !a.done; ) {
      var c = a.value, u = c.id, h = c.item;
      if (i.indexOf(u) === -1 && z(h, u, e, s, i))
        i.push(u), a = l.next();
      else
        break;
    }
  }
  function o() {
    for (; !a.done; ) {
      var c = a.value.id, u = i.indexOf(c);
      if (u > -1)
        i.splice(u, 1), a = l.next();
      else
        break;
    }
  }
  function d() {
    var c, u, h;
    return ne(this, function(p) {
      switch (p.label) {
        case 0:
          if (!e)
            return [3, 5];
          c = $(r, s, n), u = c.length - 1, p.label = 1;
        case 1:
          return u > -1 ? [4, { id: y(e, c[u]), item: t ? c[u] : void 0 }] : [3, 4];
        case 2:
          p.sent(), p.label = 3;
        case 3:
          return u--, [3, 1];
        case 4:
          return [3, 8];
        case 5:
          h = N(r), p.label = 6;
        case 6:
          return h ? [4, { id: h, item: t ? I(h, n, s) : void 0 }] : [3, 8];
        case 7:
          return p.sent(), h = N(h), [3, 6];
        case 8:
          return [
            2
            /*return*/
          ];
      }
    });
  }
}
var oe = globalThis && globalThis.__extends || function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, i) {
      s.__proto__ = i;
    } || function(s, i) {
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (s[n] = i[n]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function s() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (s.prototype = e.prototype, new s());
  };
}(), g = globalThis && globalThis.__assign || function() {
  return g = Object.assign || function(r) {
    for (var t, e = 1, s = arguments.length; e < s; e++) {
      t = arguments[e];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, g.apply(this, arguments);
}, ue = (
  /** @class */
  function(r) {
    oe(t, r);
    function t() {
      var e = r !== null && r.apply(this, arguments) || this;
      return e.state = {
        visible: !1,
        top: 0,
        left: 0,
        text: "",
        operationClassName: "cancel"
      }, e;
    }
    return t.prototype.render = function() {
      var e = { top: this.state.top + "px", left: this.state.left + "px" };
      return this.state.visible && m.createElement(
        "div",
        { className: "k-header k-drag-clue", style: g(g({}, this.props.style), e) },
        m.createElement(W, { className: Y("k-drag-status"), name: this.state.operationClassName && B(this.state.operationClassName), icon: this.state.operationClassName === "k-i-plus" ? X : this.state.operationClassName === "k-i-insert-up" ? Z : this.state.operationClassName === "k-i-insert-up" ? q : this.state.operationClassName === "k-i-insert-middle" ? Q : H }),
        this.state.text
      );
    }, t.prototype.show = function(e, s, i, n) {
      this.setState({ visible: !0, top: e, left: s, text: i, operationClassName: n });
    }, t.prototype.hide = function() {
      this.setState({ visible: !1 });
    }, t.defaultProps = { style: { display: "block", position: "absolute", zIndex: 2e4, padding: "4px 6px" } }, t;
  }(m.PureComponent)
), x = 6, fe = (
  /** @class */
  function() {
    function r(t) {
      this.event = t, this.initialized = !1, this.destItemId = "", this.destTreeViewGuid = "", this.itemId = t.itemHierarchicalIndex, this.treeViewGuid = t.target.guid;
    }
    return r.prototype.init = function() {
      return this.initialized || (this.setDestimationMeta(document.elementFromPoint(this.event.clientX, this.event.clientY)), this.initialized = !0), this;
    }, Object.defineProperty(r.prototype, "isDropAllowed", {
      /**
       * Returns `true` if dropping is allowed. Otherwise, returns `false`.
       */
      get: function() {
        return this.initialized && this.destItemId && this.destTreeViewGuid ? !"".concat(this.destTreeViewGuid, "_").concat(this.destItemId, "_").startsWith("".concat(this.treeViewGuid, "_").concat(this.itemId, "_")) : !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "destinationMeta", {
      /**
       * Returns an object which contains:
       * * The `itemHierarchicalIndex` of the destination item (the item below the dragged item) and
       * * The `guid` of the destination TreeView (the TreeView which renders the destination item).
       */
      get: function() {
        return { itemHierarchicalIndex: this.destItemId, treeViewGuid: this.destTreeViewGuid };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.getDropOperation = function() {
      if (this.initialized && this.isDropAllowed) {
        var t = this.destDomNodeWithMeta.getBoundingClientRect(), e = t.top, s = t.height;
        return e + s - this.event.clientY < x ? "after" : this.event.clientY - e < x ? "before" : "child";
      } else
        return;
    }, r.prototype.setDestimationMeta = function(t) {
      for (var e = t; e && !e[w]; )
        e = e.parentNode;
      e && e[w] && (this.destDomNodeWithMeta = e, this.destItemId = e[w], this.destTreeViewGuid = e[K]);
    }, r;
  }()
);
const Ie = "_", _e = fe, Te = m.forwardRef(function(t, e) {
  return /* @__PURE__ */ D.jsx(ue, { ...t, ref: e });
}), Ce = re, Ee = J, Oe = ie, Ne = (r) => /* @__PURE__ */ D.jsx(U, { ...r });
export {
  Ie as SEPARATOR,
  Ne as TreeView,
  _e as TreeViewDragAnalyzer,
  Te as TreeViewDragClue,
  Oe as handleTreeViewCheckChange,
  Ce as moveTreeViewItem,
  Ee as processTreeViewItems
};
